import React from "react";

const PaymentStatusGroup = ({
  paymentMethod,
  status,
  isCanceled,
  orderType,
  onClick,
}) => {
  const getPaymentConfig = (method) => {
    switch (method?.toLowerCase()) {
      case "online":
        return { color: "bg-green-500", label: "Online" };
      case "cash":
        return { color: "bg-blue-500", label: "Cash" };
      case "card":
        return { color: "bg-purple-500", label: "Card" };
      case "partial":
        return { color: "bg-orange-500", label: "Partial" };
      case "na":
      case "":
      case null:
      case undefined:
        return { color: "bg-gray-400", label: "NA" };
      default:
        return { color: "bg-gray-400", label: method || "NA" };
    }
  };

  const getStatusConfig = (status) => {
    switch (status) {
      case "paid":
        return {
          color: "bg-green-100 text-green-800 border-green-200",
          label: "Paid",
        };
      case "pending":
        return {
          color: "  bg-orange-100 text-orange-800 border-orange-200",
          label: "Live",
        };
      case "settle_later":
        return {
          color: "bg-yellow-100 text-yellow-800 border-yellow-200",
          label: "Pending",
        };
      case "cancelled":
        return {
          color: "bg-red-100 text-red-800 border-red-200",
          label: "Cancelled",
        };
      default:
        return {
          color: "bg-gray-100 text-gray-800 border-gray-300",
          label: status || "Unknown",
        };
    }
  };

  const paymentConfig = getPaymentConfig(paymentMethod);
  const finalStatus = isCanceled ? "cancelled" : status;
  const statusConfig = isCanceled
    ? getStatusConfig("cancelled")
    : getStatusConfig(status);

  return (
    <div className="space-y-2 flex flex-col items-center justify-center text-center">
      {/* Payment Method */}
      {paymentConfig.label != "NA" && (
        <div className="flex items-center justify-center space-x-2">
          <div className={`w-2 h-2 rounded-full ${paymentConfig.color}`}></div>
          <span className="text-sm font-semibold capitalize text-gray-800">
            {paymentConfig.label}
          </span>
        </div>
      )}

      {/* Status Badge */}
      <div className="space-y-1 flex flex-col items-center">
        <span
          className={`px-2 py-1 inline-flex text-xs font-semibold rounded-full border ${
            statusConfig.color
          } ${onClick ? "cursor-pointer hover:opacity-80" : ""}`}
          onClick={onClick}
        >
          {statusConfig.label}
        </span>
        {orderType === "digital" && (
          <div className="text-xs text-blue-600 font-medium">Digital Order</div>
        )}
      </div>
    </div>
  );
};

export default PaymentStatusGroup;
